<div class="notifications_panel hidden">
  <div class="notifications_panel_header">
    <span>{{'Notifications'|translate }}</span>
    <div>
      <button class="btn_img_large btn_bell_on" id="disableSoundBtn" title="{{'Disable sound'|translate }}"></button>
      <button class="btn_img_large btn_delete_all" id="ackAllBtn" title="{{'Acknowledge all'|translate }}"></button>
    </div>
  </div>
  <div class="notifications_list">
  </div>  
  <div class="notifications_panel_footer" (click)="this.toggleNotificationsPanel()">
    {{'Close'|translate }}
  </div>
</div>
<div class="new_notifications">
  <div class="new_notifications_list">
  </div>
</div>
